module.exports = __webpack_public_path__ + "img/c14.406d8913.png";